import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Button, Radio, Select, Badge, Modal } from 'antd'
import { bulkAddEditEvents, getEvents } from '../../store/action/event.action'
import '../../css/messages.scss'
import { getAllSurgeryTypes } from '../../store/action/profile.action'
import {
  BellFilled,
  ExclamationCircleOutlined,
  NotificationFilled,
} from '@ant-design/icons'
import serviceInterface from '../../services/service.interface'
import { constants } from '../../constants'
import util from '../../util/util'

const EventAction = (props) => {
  const [confirm, setConfirm] = useState(false)

  console.log(confirm)

  useEffect(() => {
    props.getSurgerytypes()
  }, [])

  useEffect(
    () => props.types && changeSurgertype(props.types[0]._id),
    [props.types]
  )

  const checkIfEdited = () => {
    for (var i = 0; i < props.editedEvents?.length; i++)
      if (props.editedEvents[i].isEdited) return true
    return false
  }

  const handleChange = (value) => {
    checkIfEdited() ? setConfirm(value) : changeSurgertype(value)
  }

  const changeSurgertype = (value) => {
    props
      .getEvents({
        surgerytype: value,
        customer: props.customer?._id,
        company: props.company?._id,
      })
      .then(() => setConfirm(false))
  }

  var verifyRoles = (roles = []) => {
    if (roles.length == 0) return true
    return serviceInterface.AuthService().authorize_role(roles, props.decoded)
  }

  const handleSave = () => {
    var evs = props.editedEvents
      .filter((e) => e.isEdited)
      .map((e) => {
        delete e.isEdited
        delete e.__typename
        return e
      })
    props.bulkSave({
      surgerytype: props.surgerytype,
      customer: props.customer?._id,
      company: props.company?._id,
      events: evs,
    })
    changeSurgertype(confirm)
  }

  const handleCancel = () => {
    props.getEvents({
      surgerytype: props.surgerytype,
      customer: props.customer?._id,
      company: props.company?._id,
    })
    changeSurgertype(confirm)
  }

  const renderOptions = () => {
    return props.types?.map((type) => {
      return <Select.Option value={type._id}>{type?.name}</Select.Option>
    })
  }

  return (
    <>
      <Row className={'actionRow'}>
        <Col flex={'30%'}>
          <Row className={'headerText'} align='middle' wrap={false} gutter={10}>
            <Col> Reminders </Col>
            <Col hidden={verifyRoles([constants.ROLE.SUPER_ADMIN])}>
              <Badge size='small' count={props.isUpdated ? 1 : 0}>
                <Button
                  shape='circle'
                  type='primary'
                  icon={<BellFilled />}
                  onClick={() => props.openDrawer()}
                />
              </Badge>
            </Col>
          </Row>
          <Row hidden={props.surgerytype}>
            <i>*Please select a surgery type.*</i>
          </Row>
        </Col>
        <Col style={{ alignSelf: 'flex-end' }} flex={'auto'}>
          <Row justify={'end'} align={'middle'} wrap={false} gutter={10}>
            <div id={'reminderfilter'}>
              <Col margin={10}>Surgery Type: </Col>
              <Col>
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  value={
                    !props.surgerytype && props.types
                      ? props.types[0]._id
                      : props.surgerytype
                  }
                  style={{ width: 160 }}
                  onChange={handleChange}
                  autoFocus={false}
                  defaultOpen={false}
                  defaultActiveFirstOption={false}
                  placeholder={'Select surgery type.'}
                >
                  {renderOptions()}
                </Select>
              </Col>
            </div>
          </Row>
          <Row hidden justify={'end'} align={'bottom'} style={{ marginTop: 5 }}>
            <Button
              disabled={!props.surgerytype}
              className={'actionBtn'}
              onClick={props.openAddModal}
            >
              ADD
            </Button>
          </Row>
        </Col>
      </Row>
      <Modal
        visible={confirm}
        footer={false}
        onCancel={() => setConfirm(false)}
      >
        <Row>
          <Col flex={'38px'}>
            <ExclamationCircleOutlined
              style={{ color: '#faad14', fontSize: 22, marginTop: 5 }}
            />
          </Col>
          <Col flex={'auto'}>
            <Row>
              <h2>Confirm</h2>
            </Row>
            <Row>
              <p>
                Please publish your changes before selecting another surgery
                type!
              </p>
            </Row>
          </Col>
        </Row>
        <Row justify='end' gutter={8} wrap={false}>
          <Col>
            <Button
              onClick={() => setConfirm(false)}
              className='et-cancel-round-btn'
            >
              Cancel
            </Button>
          </Col>
          <Col>
            <Button onClick={handleCancel} className='et-cancel-round-btn'>
              Discard
            </Button>
          </Col>
          <Col>
            <Button onClick={handleSave} className='et-round-btn'>
              Publish
            </Button>
          </Col>
        </Row>
      </Modal>
    </>
  )
}

EventAction.propTypes = {
  selectedRequests: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    types: state.profile.types,
    customer: state.profile.customer,
    company: state.profile.company,
    surgerytype: state.event.surgerytype,
    isUpdated: state.event.isUpdated,
    decoded: util.verifyToken(state.profile.token, true),
    editedEvents: state.event.tempevents,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getEvents: (params) => dispatch(getEvents(params)),
    getSurgerytypes: () => dispatch(getAllSurgeryTypes()),
    bulkSave: (params) => dispatch(bulkAddEditEvents(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventAction)
